/**
 * AdminClient singleton for the web app.
 *
 * baseUrl is read from VITE_API_BASE_URL at build time; in dev, Vite reads
 * it from .env.development. In CI + deployed envs, the build step injects
 * the tilt-admin-api's ApiEndpoint CFN output (or later, the vanity
 * `api.{env}.apps.myfinterra.com` once the portal routing CFN lands).
 */

import { AdminClient, type TokenStore } from "@tilt/admin-sdk";

import { cognitoTokenStore } from "./auth";

const baseUrl = import.meta.env.VITE_API_BASE_URL as string | undefined;

if (!baseUrl) {
  // Fail loudly in dev rather than hitting a relative URL that would
  // never resolve from the browser.
  console.warn(
    "[tilt-admin] VITE_API_BASE_URL is not set. Create apps/web/.env.development.local with:\n" +
      "  VITE_API_BASE_URL=https://<your-tilt-admin-api-dev-execute-api-url>",
  );
}

const tokens: TokenStore = cognitoTokenStore;

export const apiClient = new AdminClient({
  baseUrl: baseUrl ?? "http://localhost:0",
  tokens,
});
